import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getFirestore, doc, updateDoc } from 'firebase/firestore';
import { useAuth } from '../contexts/AuthContext';

export const LanguageSelector: React.FC = () => {
  const { i18n } = useTranslation();
  const { currentUser } = useAuth();
  const db = getFirestore();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const changeLanguage = async (language: string) => {
    i18n.changeLanguage(language);
    localStorage.setItem('language', language);
    
    if (currentUser) {
      try {
        const userRef = doc(db, 'users', currentUser.uid);
        await updateDoc(userRef, {
          language
        });
      } catch (error) {
        console.error('Error updating language in Firestore:', error);
      }
    }
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const currentLanguage = i18n.language === 'es' ? 'Español' : 'English';
  const currentFlag = i18n.language === 'es' ? '🇲🇽' : '🇺🇸';

  return (
    <div ref={dropdownRef} className="fixed top-5 right-5 z-50">
      <button 
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-4 py-2 bg-white border-2 border-red-500 rounded-lg cursor-pointer text-sm text-gray-800 transition-all duration-300 ease-in-out hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-20"
      >
        <span className="text-lg">{currentFlag}</span>
        <span>{currentLanguage}</span>
      </button>
      
      {isOpen && (
        <div className="absolute top-full right-0 mt-2 bg-white border-2 border-red-500 rounded-lg shadow-lg min-w-[120px]">
          <div 
            onClick={() => changeLanguage('es')}
            className="flex items-center gap-2 px-4 py-2 cursor-pointer transition-colors duration-300 ease-in-out hover:bg-red-50 rounded-t-md"
          >
            <span className="text-lg">🇲🇽</span>
            <span>Español</span>
          </div>
          <div 
            onClick={() => changeLanguage('en')}
            className="flex items-center gap-2 px-4 py-2 cursor-pointer transition-colors duration-300 ease-in-out hover:bg-red-50 rounded-b-md"
          >
            <span className="text-lg">🇺🇸</span>
            <span>English</span>
          </div>
        </div>
      )}
    </div>
  );
}; 